import React, { useRef, useContext, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Icon } from "@iconify/react/dist/iconify.js";
import { LangButton } from "../../../language/lang-button";
import { NotificationButton } from "../../components/notification-button";
import { useAccessibility } from "../../../../hooks/useAccessibility";
import { store } from "../../../Store";

/**
 * Componente que renderiza los botones Ingresar, accesibilidad, notificaciones e idioma
 * @param {*} textosInterfaz - objeto con los textos de interfaz 
 * @returns {JSX.Element} Tools
 */
export const Tools = ({ textosInterfaz }) => {
    const location = useLocation();

    const globalState = useContext(store);
    const accessibility = useAccessibility();
    const accessibilityButtonRef = useRef(null);

    /*Asigna el botón que abre las opciones de accesibilidad */
    useEffect(() => {
        if (accessibilityButtonRef.current) {
            globalState.dispatch({
                type: "CHANGE",
                path: "accessibility.triggerButton",
                value: accessibilityButtonRef,
            });
        }
    }, [accessibilityButtonRef]);

    return (
        <ul className="option-nav d-flex justify-content-end aling-items-center">
            {location.pathname !== '/institucional/formulario' &&
                <li>
                    <div className="ingresar pr-2">
                        <Link
                            to="/login"
                            className={`focusable-red ml-1  ${location.pathname === '/login' ? "btn-header activeMode" : "btn-header"}`}
                        >
                            {textosInterfaz?.ingresar || 'Ingresar'}
                        </Link>
                    </div>
                </li>
            }
            <li className={`ml-2`}>
                <button
                    ref={accessibilityButtonRef}
                    aria-expanded={accessibility.state.visible}
                    aria-label={textosInterfaz?.button_accesibility_description}
                    className={`focusable-red ${accessibility.state.visible ? 'icon-button activeMode' : 'icon-button'} `}
                    onClick={() => { accessibility.setVisible(!accessibility?.state?.visible) }}
                >
                    <Icon
                        icon="la:universal-access"
                        width="30" height="30"
                    />
                </button>
            </li>
            
            <NotificationButton />

            <li>
                <LangButton />
            </li>
        </ul>
    )
}